import React from "react";
import PropTypes from "prop-types";
import { Button, Col, Container, Row } from "react-bootstrap";
import { graphql } from "gatsby";

import RichTextBlock from "./RichTextBlock";
import GatsbyImageWithSVGSupport from "./GatsbyImageWithSVGSupport";

import "../styles/components/Cards.scss";
import { getCtaProps } from "../utils/utils";

const Cards = ({ title, lead, cards }) => {
    if (!cards?.length) return null;

    return (
        <Container className="text-center">
            <h2>{title}</h2>
            <RichTextBlock content={lead} />

            <Row>
                {cards?.map(card => {
                    const btnProps = getCtaProps(card.ctaLink);

                    return (
                        <Col key={card.id} className="my-3" md={4}>
                            <div className="card">
                                {card.image && (
                                    <>
                                        <GatsbyImageWithSVGSupport
                                            className="bg-image"
                                            image={card.image}
                                        />

                                        <div className="overlay" />
                                    </>
                                )}
                                <div className="info p-3">
                                    <h3 className="text-center text-white">
                                        {card.title}
                                    </h3>
                                    {btnProps && (
                                        <Button
                                            variant="link"
                                            {...btnProps}
                                            className="text-white  mt-auto"
                                        >
                                            Learn More &#x279C;
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </Col>
                    );
                })}
            </Row>
        </Container>
    );
};

export const query = graphql`
    fragment DynamicCards on ContentfulCards {
        sys {
            contentType {
                sys {
                    id
                }
            }
        }
        title
        lead {
            raw
        }
        cards {
            id
            title
            image {
                gatsbyImageData(layout: CONSTRAINED)
                title
                description
                file {
                    contentType
                    url
                }
            }
            ctaLink
        }
    }
`;

Cards.propTypes = {
    title: PropTypes.string.isRequired,
    lead: PropTypes.shape({
        raw: PropTypes.string.isRequired,
    }),
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            image: PropTypes.shape({
                title: PropTypes.string,
                description: PropTypes.string,
                mimeType: PropTypes.string,
                gatsbyImageData: PropTypes.object,
                file: PropTypes.shape({
                    contentType: PropTypes.string.isRequired,
                    url: PropTypes.string.isRequired,
                }),
            }).isRequired,
            ctaLink: PropTypes.string.isRequired,
        })
    ).isRequired,
};

export default Cards;
